import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box } from "@mui/material";
// import Link from "next/link";
import { Link } from "react-router-dom";

// interface BreadCrumbsProps {
//   data: any;
// }
// const BreadCrumbsComponent: React.FC<BreadCrumbsProps> = ({ data }) => {
const BreadCrumbsComponent = ({ data }) => {
  // const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
  const handleClick = () => {
    //    event.preventDefault();
  };

  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        {data?.map((singleLinkInfo, index) => (
          <Box key={index}>

            {/* <Link href={singleLinkInfo?.link}> */}
            <Link to={singleLinkInfo?.link}>
              <Box
                color={data?.length == index + 1 ? "rgba(221, 110, 16,1)" : "rgba(221, 110, 16,1)"}
                sx={{
                  fontWeight: "bold",
                  fontSize: '16px',
                  "&:hover": {
                    textDecoration: "underline grey",
                  },
                }}
              >
                {singleLinkInfo?.name}
              </Box>
            </Link>

          </Box>
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default BreadCrumbsComponent;
